import classNames from 'classnames';
import * as React from 'react';
import { ConfigContext } from '../config-provider';
import { PresetColorTypes, PresetStatusColorTypes } from '../_util/colors';
import Wave from '../_util/wave';
const PresetColorRegex = new RegExp(`^(${PresetColorTypes.join('|')})(-inverse)?$`);
const PresetStatusColorRegex = new RegExp(`^(${PresetStatusColorTypes.join('|')})$`);
const InternalStatus = ({ prefixCls: customizePrefixCls, className, style, children, type }, ref) => {
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const isPresetColor = () => {
        if (!type) {
            return false;
        }
        return PresetColorRegex.test(type) || PresetStatusColorRegex.test(type);
    };
    const statusStyle = Object.assign({ backgroundColor: type && !isPresetColor() ? type : undefined }, style);
    const presetColor = isPresetColor();
    const prefixCls = getPrefixCls('status', customizePrefixCls);
    const statusClassName = classNames(prefixCls, {
        [`${prefixCls}-${type}`]: presetColor,
        [`${prefixCls}-has-color`]: type && !presetColor,
        [`${prefixCls}-rtl`]: direction === 'rtl',
    }, className);
    const statusNode = (React.createElement("span", { ref: ref, className: statusClassName, style: statusStyle }, children));
    return React.createElement(Wave, null, statusNode);
};
const Status = React.forwardRef(InternalStatus);
if (process.env.NODE_ENV !== 'production') {
    Status.displayName = 'Status';
}
export default Status;
